import { loadAudioSounds } from "helpers/sounds";
import React from "react";
import ReactDOM from "react-dom";
import { useDispatch } from "react-redux";
import { signMeOut } from "slices/authSlice";
import {
  setAccountDetailsModal,
  setDeviceSettingsModal,
  // setDeviceSettingsModal,
} from "slices/extraOptionsSlice";

const ExtraOptionsModal = ({ onDismiss }) => {
  const dispatch = useDispatch();

  return ReactDOM.createPortal(
    <div
      className={`modal-backdrop`}
      onClick={(e) => {
        onDismiss(e);
        e.stopPropagation();
      }}
    >
      <div className="extra-options-box" onClick={(e) => e.stopPropagation()}>
        <div className="d-flex flex-column justify-content-around">
          <div
            className="EO-right-buttons"
            onClick={() => {
              signMeOut();
              onDismiss();
            }}
          >
            Sign Out
          </div>
          <div
            className="EO-right-buttons"
            onClick={() => {
              dispatch(setAccountDetailsModal(true));
              onDismiss();
            }}
          >
            Account
          </div>
          <div
            className="EO-right-buttons"
            onClick={() => {
              loadAudioSounds();
              dispatch(setDeviceSettingsModal(true));
              onDismiss();
            }}
          >
            Device Settings
          </div>
        </div>
      </div>
    </div>,
    document.querySelector("#modal")
  );
};

export default ExtraOptionsModal;
